import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import PushCode from '../pushSource/key';
import CustomSourceKey from '../customSource/key';
import { SourcePipeConfig } from '../../interface';
import {
    EnhancedNewOrderPushData,
    PushOrderUserRole,
    OrderBusinessType,
    NewOrderPushData as RawNewOrderPushData,
    WmOrderDetail,
} from './baseBranch/newOrderPushPipe';

export type NewOrderPushData = {
    origin: RawNewOrderPushData<PushOrderUserRole.NORMAL>;
    detail: WmOrderDetail | null;
};

/** 普通订单分流 */
export const orderBranch: SourcePipeConfig<PushCode, CustomSourceKey> = {
    push: {
        [PushCode.NEW_ORDER_1]: (source$: Observable<EnhancedNewOrderPushData>) => {
            return source$.pipe(
                filter(data => {
                    return (
                        // prettier-ignore
                        // 普通订单的 user_role 只可能为 -1
                        data.origin.user_role === PushOrderUserRole.NORMAL
                        // 如果 detail 为 null（自动接单请求详情失败或非自动接单），走默认的线上逻辑（由普通订单分流处理）；否则为外卖订单
                        && (data.detail === null || data.detail.businessType === OrderBusinessType.WM)
                    );
                }),
            ) as Observable<NewOrderPushData>;
        },
    },
} as SourcePipeConfig<PushCode, CustomSourceKey>;

export default orderBranch;
